// [MEMO] lucy: 캠코 시연을 위한 상수입니다.
export const KAMCO_CONFIG = {
    BASE_WMTS_URL: 'https://kamco-2021.geoserver.gs.dabeeo.com/geoserver/gwc/service/wmts',
    BASE_WMTS_LAYER: 'korea:raster_vrt_rgb',
    TARGET_WMTS_URL: 'https://kamco-2022.geoserver.gs.dabeeo.com/geoserver/gwc/service/wmts',
    TARGET_WMTS_LAYER: 'korea:raster_vrt_rgb',
    KAMCO_DEMO_REQUEST_ID: 1781335334886550,
    KAMCO_CUSTOM_LAYER_URL: 'https://resource.plantation.dabeeo.com/3d/changwon_cd_v6_2021_2022_earth.geojson'
} as const;